import { RenderCtrl } from "../shared/render.component";
class RenderTemplateCtrl extends RenderCtrl{
  constructor(
    $scope,
    $sce,
    RenderService
  ) {
    'ngInject';
    super(RenderService, $scope);

    this.$sce = $sce;
    this.imgsLoaded = [];
    this.pageUrls = [];
    this._renderContainer = null;
  }

  get renderContainer() {
    this._renderContainer = this._renderContainer || this.$document.querySelector(".render-template");
    return this._renderContainer;
  }

  get isCustomView () {
    return !(this.isBackendCall || this.td.template.pageView === "fullscreen" || this.ds.isMobileWidth());
  }

  async $onInit() {

    try {
      await super.$onInit();
      if (!this.td) return;
      this.applyTabNumbers();
      this.customCssHtml = this.$sce.trustAsHtml(this.td.template.customCss);
      this.containerCss = this.getContainerCss();
    } catch (error) {
      this.handleError(error);
    }
    
    this.$timeout(_ => { if (!this.redirURL) this.busyMessage = ''; } );
  }
  
  getContainerCss() {
    if (!this.isCustomView) return "";
    // Add custom widths here:
    const pageViewWidth = this.td.template.pageView == "pageview" ? "8.5in": "";
    return `@media not print {
      .bg-img { border-bottom: 1px dotted lightgray; }
      render-template { display: flex; justify-content: center; align-items: center; flex-direction: column; }
      .render-template { width:${pageViewWidth}; }
      render-template { min-width:${pageViewWidth}; }
      #render-container loader .app-loading { min-height: 40vw !important; }
      #render-container { box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19); min-height: 80vh; }
      #user-message-container { max-width: 100%; } }`;
  }

  getTokenStyle(token) {
    const style = ((token.control.defaultCss || '') + token.layout);
    if (!this.isCustomView) return style;
    return this.convertVwToPx(style);
  }

  convertVwToPx(cssString) {
    const screenWidth = this.$window.innerWidth;
    const proportion = this.renderContainer.offsetWidth / screenWidth;
    const convertedCss = cssString.replace(
      /([\d.]+)vw/g, (_, num) => {
        const adjustedPx = parseFloat(num) * proportion * screenWidth / 100;
        return `${adjustedPx.toFixed(2)}px`;});
    return convertedCss;
  }

  applyTabNumbers() { 
    this.tabNumbers = this.ds.getTabNumbers(this.ts.partialPages, this.ts.tokens);
  }
  
  async beforeLoaded() {
    await Promise.all([
      super.beforeLoaded(),
      this.watchImgLoad()
    ]);
  }
  
  watchImgLoad() {
    return new Promise((res, rej) => {
      const ivl = this.$interval(() => {
        if (this.imgsLoaded.length !== (this.td?.template?.partialPages?.length || 0)) return;
        this.$interval.cancel(ivl);
        this.imgsLoaded.reduce((a,v) => a && v, true) ? res(true) : rej("Page Load Error");
      }, 200);
    });
  }

}

export default {
  bindings: {},
  templateUrl: "form-render/render-template/render-template.component.html",
  controller: RenderTemplateCtrl
}
